<template>
  <div>
    <div class="sf-pad-v-2 sf-font-xl">{{ props.title }}</div>
    <sf-table
      :headers="headers"
      :rows="props.rows"
      :initial-sort-by="'number'"
      :sticky-header="true"
    >
      <template
        #header="{ header, headerIndex, headerLabel, sortBy, sortDirection }"
      >
        <a class="sf-a sf-c-text" :data-testid="`sf-header-${headerIndex}`">
          {{ headerLabel }}
        </a>
        <i class="fa" :class="sortingArrow(header.id, sortBy, sortDirection)" />
        <account-table-header-badge v-if="headerIndex === 1" />
      </template>

      <template #row="{ rowData, id }">
        <account-table-item
          :item="rowData"
          :item-id="id"
          :focused="groupListStore.focusedDropdown === id"
        />
      </template>
    </sf-table>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import sfTable from '@app/shared/vue/components/sf-table/index.vue'
import AccountTableItem from './account-table-item.vue'
import { useGroupList } from '../store/group-list'
import { AccountTableRow } from '../shared-types'
import { SfTableHeaderConfig } from '@app/shared/vue/components/sf-table/types'
import { tableSortDirections } from '@app/shared/vue/components/constants'
import AccountTableHeaderBadge from './account-table-header-badge.vue'

interface Props {
  rows: Array<AccountTableRow>
  title: string
}

const props = defineProps<Props>()

const groupListStore = useGroupList()
const headers = computed(() => {
  return [
    {
      id: 'status',
      label: ' ',
      width: '35px',
    },
    {
      id: 'mappedAccountNumber',
      label: window.I18n.t('account_mapping_list.table_headers.mapped_name'),
      width: '42%',
    },
    {
      id: 'number',
      label: window.I18n.t('account_mapping_list.table_headers.import_name'),
      width: '42%',
    },
    {
      id: 'sortableBalance',
      label: window.I18n.t('account_mapping_list.table_headers.balance'),
      width: '6%',
    },
    {
      id: 'mappedAccountType',
      label: window.I18n.t('account_mapping_list.table_headers.account_type'),
      width: 'auto',
    },
  ] as Array<SfTableHeaderConfig>
})

const sortingArrow = function (
  headerId: string,
  sortBy: string,
  sortDirection: string
) {
  const currentSort = headerId === sortBy

  const caretClassBySortDirection =
    sortDirection === tableSortDirections.DESC ? 'fa-caret-down' : 'fa-caret-up'

  const caretClass = currentSort ? caretClassBySortDirection : 'fa-caret-down'

  const colorClass = currentSort ? 'sf-c-primary' : 'sf-c-text-lighter'

  return [caretClass, colorClass]
}
</script>
